import useCurrentReport from '../../../../hooks/useCurrentReport'
import useUpdateReportDoc from '../../../../hooks/useUpdateReportDoc'
import { VitalStats } from '../../../../types/MonthlyReport'
import { VitalStatsState } from '../utils/types'

export const useVitalStatsState = (): VitalStatsState => {
  const stats: Partial<VitalStats> = useCurrentReport()?.vitalStats || {}
  const updateReport = useUpdateReportDoc()

  const update = (partial: Partial<VitalStats>) => {
    updateReport({
      vitalStats: {
        ...stats,
        ...partial,
      },
    })
  }

  return { stats, update }
}
